import GreyLoadingOverlay from '@/components/loading/GreyLoadingOverlay';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import { Button, ButtonTypeMap } from '@mui/material';
import { CommonProps } from '@mui/material/OverridableComponent';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { unFollow } from '../../../../apis/follow.api';
import { PATH_NAME } from '../../../../configs/pathName';
import useFollow from '../../../../hooks/useFollow';
import useToast from '../../../../hooks/useToast';
import { QuickLoginModalHOC } from '../../../modal/LoginModal2HOC';
const mapFollowContent: { [key: string]: string } = {
  ['false']: 'Theo dõi',
  ['true']: 'Đang theo dõi',
};

const BusinessFollowButton = ({
  bizProfileId,
  isFollowed,
  props,
  showIcon = false,
  opt,
}: {
  bizProfileId: string;
  isFollowed: boolean;
  props?: ButtonTypeMap<CommonProps>;
  showIcon?: boolean;
  opt?: {
    onFollowSuccess?: Function;
    onFollowError?: Function;
    onUnFollowSuccess?: Function;
    onUnFollowError?: Function;
  };
}) => {
  const [isFollowedState, setIsFollowedState] = useState(isFollowed);
  const { requestFollow } = useFollow();
  const router = useRouter();
  const newToast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsFollowedState(isFollowed);
  }, [isFollowed]);

  const handleFollowBiz = () => {
    setIsLoading(true);
    requestFollow({
      userId: bizProfileId,
      callback: () => {
        setIsFollowedState((p) => !p);
        opt?.onFollowSuccess && opt?.onFollowSuccess();
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
        opt?.onFollowError && opt?.onFollowError();
      },
    });
  };

  const handleUnFollow = async () => {
    setIsLoading(true);
    try {
      await unFollow(bizProfileId);
      setIsFollowedState((p) => !p);
      opt?.onUnFollowSuccess && opt?.onUnFollowSuccess();
    } catch (error) {
      newToast('Có lỗi xảy ra, vui lòng thử lại sau.', 'error');
      opt?.onUnFollowError && opt?.onUnFollowError();
    }
    setIsLoading(false);
  };

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="relative"
    >
      <QuickLoginModalHOC
        handleClickWhenDisabledQuickLogin={() => {
          isFollowedState ? handleUnFollow() : handleFollowBiz();
        }}
        loginSuccessCb={() => {
          router.push({
            pathname: PATH_NAME.PROFILE,
            query: {
              uid: bizProfileId,
            },
          });
          isFollowedState ? handleUnFollow() : handleFollowBiz();
        }}
      >
        <Button
          {...props?.props}
          startIcon={
            !showIcon ? null : isFollowedState ? <DoneIcon /> : <AddIcon />
          }
        >
          <div className="text-sm font-semibold leading-[16px]">
            {mapFollowContent[`${isFollowedState}`]}
          </div>
        </Button>
      </QuickLoginModalHOC>
      <GreyLoadingOverlay show={isLoading} size={20} />
    </div>
  );
};

export default BusinessFollowButton;
